import React from 'react';
import "./Conditions.css";

const Conditions = () => (
  <div className="policy-container">
    <h1>TERMS AND CONDITIONS</h1>
    <p>All sales are subject to the following terms and conditions:</p>

    <ol className="policy-list">
      <li>All sales are subject to product availability.</li>
      <li>Prices are subject to change without notice but will always be confirmed before payment.</li>
      <li>Custom orders require a 70 percent deposit before production begins. Deposits are non-refundable.</li>
      <li>Delivery timelines are estimates and may vary due to unforeseen logistics delays.</li>
      <li>Clients are responsible for providing accurate delivery details; Posher will not be liable for losses due to incorrect information.</li>
      <li>Intellectual property: All designs, images, and content remain the property of Posher and cannot be used without permission.</li>
      <li>By purchasing from Posher, you agree to these terms and conditions.</li>
    </ol>
  </div>
);

export default Conditions;
